export default __webpack_public_path__ + "static/media/brandmark.dd94c817.png";